import { createGlobalStyle } from "styled-components"

import { fonts } from "@izettle/otto"

type FontType = (typeof fonts)[keyof typeof fonts]
type FontVersionType = { file: string; weight: string }

const getFontFile = (file: string) => (format: string) => `url(${file}.${format})`

const getFontFace =
  ({ name, formats }: Omit<FontType, "fonts">) =>
  ({ file, weight }: FontVersionType) =>
    `
  @font-face {
    font-family: ${name};
    font-weight: ${weight};
    src: ${formats.map(getFontFile(file)).join(", ")};
  }
`

const getFontFamily = ({ fonts: fontVersions, ...fontProps }: FontType) =>
  Object.values(fontVersions).map(getFontFace(fontProps)).join("")

const fontFamiliesMixin = Object.values(fonts).map(getFontFamily).join("")

/**
 * 1. Applies `box-sizing: border-box` to all elements.
 * 2. Declares @font-face for Zen and Dingbatz.
 * 3. Sets Zen as the default font-family for all elements.
 */
export const GlobalOttoStyles = createGlobalStyle`
  ${fontFamiliesMixin}

  * {
    font-family: ${fonts.zen.name};
    box-sizing: border-box;
  }
`
